import I18n from 'lib/i18n/i18n'
import {isMobile}from 'helpers/ApplicationHelper'

export default function() {
    return (
        {
            ring:{
                selectedFieldName: 'jewelry_style_ring_1',
                jewelryType: [
                    {
                        type: 'hidden',
                        name: 'item_type_id',
                        value: '1'
                    },
                    {
                        type: 'hidden',
                        name: 'desc',
                        value: 'Rings'
                    },
                    {
                        type: 'hidden',
                        name: 'initial_transaction_type',
                        value: '1'
                    },
                    {
                        type: 'hidden',
                        name: 'item_type_1',
                        value: '1'
                    },
                    {
                        type: 'hidden',
                        name: 'type_1',
                        value: 'jewelry_rings'
                    },
                    {
                        type: 'hidden',
                        name: 'type_2',
                        value: 'diamond_center_stone'
                    },
                    {
                        type: 'hidden',
                        name: 'jewelry_metal_weight',
                        value: '5'
                    },
                    {
                        type: 'hidden',
                        name: 'ring_size',
                        value: 'ring_size_6_25'
                    }
                ],
                looseDiamondType: [
                    {
                        type: 'hidden',
                        name: 'item_type_id',
                        value: '4'
                    },
                    {
                        type: 'hidden',
                        name: 'desc',
                        value: 'Loose Diamonds'
                    },
                    {
                        type: 'hidden',
                        name: 'initial_transaction_type',
                        value: '1'
                    },
                    {
                        type: 'hidden',
                        name: 'item_type_1',
                        value: '4'
                    },
                    {
                        type: 'hidden',
                        name: 'type_1',
                        value: 'diamond_loose_diamonds'
                    }
                ],
                diamondSettings: [
                    {
                        type: 'hidden',
                        name: 'diamond_color_shade',
                        value: 'diamond_color_shade_na'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_cut_grade',
                        value: 'diamond_cut_grade_very_good'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_polish',
                        value: 'diamond_polish_very_good'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_symmetry',
                        value: 'diamond_symmetry_very_good'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_fluorescence_intensity',
                        value: 'diamond_fluorescence_intensity_none'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_diamond_treated',
                        value: 'diamond_diamond_treated_no'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_clarity_enhanced',
                        value: 'diamond_clarity_enhanced_no'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_color_enhanced',
                        value: 'diamond_color_enhanced_no'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_chips',
                        value: 'diamond_chips_none'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_inclusions_location',
                        value: 'diamond_inclusions_location_none'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_inclusions_level',
                        value: 'diamond_inclusions_level_eye_clean'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_culet_size',
                        value: 'diamond_culet_size_none'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_culet_condition',
                        value: 'diamond_culet_condition_natural'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_certificate',
                        value: 'diamond_certificate_none'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_setting_type',
                        value: 'diamond_setting_type_prong'
                    },
                    {
                        type: 'hidden',
                        name: 'diamond_type',
                        value: 'diamond_type_natural'
                        // value: 'stone_type_diamond'
                    },
                    {
                        type: 'hidden',
                        name: 'stone_type',
                        value: 'stone_type_diamond'
                    }
                ],
                inputs: [
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::ring::setting::label'),
                        name: 'jewelry_style_ring_1',
                        className: 'jewelry-style-ring-select',
                        options: [
                            {label: I18n.getString('submitForm::ring::setting::settings::solitaire'), value: 'jewelry_style_ring_solitaire', className: 'jewelry-style-ring jewelry-style-ring-solitaire'},
                            {label: I18n.getString('submitForm::ring::setting::settings::bridalSet'), value: 'jewelry_style_ring_bridal_set', className: 'jewelry-style-ring jewelry-style-ring-bridal-set'},
                            {label: I18n.getString('submitForm::ring::setting::settings::3stone'), value: 'jewelry_style_ring_3_stone', className: 'jewelry-style-ring jewelry-style-ring-3-stone'},
                            {label: I18n.getString('submitForm::ring::setting::settings::halo'), value: 'jewelry_style_ring_halo', className: 'jewelry-style-ring jewelry-style-ring-halo'},
                            {label: I18n.getString('submitForm::ring::setting::settings::looseDiamond'), value: 'jewelry_style_ring_loose_diamond', className: 'jewelry-style-ring jewelry-style-ring-loose-diamond'},
                            {label: I18n.getString('submitForm::ring::setting::settings::other'), value: 'jewelry_style_ring_other', className: 'jewelry-style-ring jewelry-style-ring-other'}
                        ],
                        scrollToOnOpen: false
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::ring::cut::label'),
                        name: 'diamond_shape_2',
                        className: 'diamond-shape-select',
                        topText: I18n.getString('submitForm::ring::cut::description1'),
                        options: [
                            {label: I18n.getString('submitForm::ring::cut::cuts::round'), value: 'diamond_shape_round', className: 'diamond-shape diamond-shape-round'},
                            {label: I18n.getString('submitForm::ring::cut::cuts::princess'), value: 'diamond_shape_princess', className: 'diamond-shape diamond-shape-princess'},
                            {label: I18n.getString('submitForm::ring::cut::cuts::cushion'), value: 'diamond_shape_cushion', className: 'diamond-shape diamond-shape-cushion'},
                            {label: I18n.getString('submitForm::ring::cut::cuts::marquise'), value: 'diamond_shape_marquise', className: 'diamond-shape diamond-shape-marquise'},
                            {label: I18n.getString('submitForm::ring::cut::cuts::emerald'), value: 'diamond_shape_emerald', className: 'diamond-shape diamond-shape-emerald'},
                            {label: I18n.getString('submitForm::ring::cut::cuts::other'), value: 'diamond_shape_other', className: 'diamond-shape diamond-shape-other'}

                        ],
                        scrollToOnOpen: false
                    },
                    {
                        type: 'number',
                        label: I18n.getString('submitForm::ring::carat::label'),
                        name: 'diamond_carat_weight_2',
                        topText: I18n.getString('submitForm::ring::carat::description1'),
                        additionalText: I18n.getString('submitForm::ring::carat::description2', {'minCarat': I18n.getFloat('submitForm::ring::carat::minCarat').toFixed(2)}),
                        className: 'diamond-carat-input',
                        minValue: I18n.getFloat('submitForm::ring::carat::minCarat'),
                        tip: I18n.getString('submitForm::ring::carat::tip'),
                        scrollToOnOpen: false,
                        withSuggestions: true
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::ring::color::label'),
                        name: 'diamond_color_2',
                        topText: I18n.getString('submitForm::ring::color::description1'),
                        className: 'diamond-color-select',
                        options: [
                            {label: I18n.getString('submitForm::ring::color::colors::notSure'), value: 'diamond_color_not_sure'},
                            {label: 'D', value: 'diamond_color_d'},
                            {label: 'E', value: 'diamond_color_e'},
                            {label: 'F', value: 'diamond_color_f'},
                            {label: 'G', value: 'diamond_color_g'},
                            {label: 'H', value: 'diamond_color_h'},
                            {label: 'I', value: 'diamond_color_i'},
                            {label: 'J', value: 'diamond_color_j'},
                            {label: 'K', value: 'diamond_color_k'},
                            {label: 'L', value: 'diamond_color_l'},
                            {label: 'M-Z', value: 'diamond_color_m_z'},
                            {label: I18n.getString('submitForm::ring::color::colors::fancy'), value: 'diamond_color_fancy'}
                        ],
                        tip: I18n.getString('submitForm::ring::color::tip'),
                        scrollToOnOpen: false,
                        defaultValue: 'diamond_color_not_sure',
                        optional: true
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::ring::clarity::label'),
                        name: 'diamond_clarity_2',
                        topText: I18n.getString('submitForm::ring::clarity::description1'),
                        className: 'diamond-clarity-select',
                        options: [
                            {label: I18n.getString('submitForm::ring::clarity::clarities::notSure'), value: 'diamond_clarity_not_sure', className: 'diamond-clarity diamond-clarity-not-sure'},
                            {label: 'FL', value: 'diamond_clarity_fl', className: 'diamond-clarity diamond-clarity-fl'},
                            {label: 'IF', value: 'diamond_clarity_if', className: 'diamond-clarity diamond-clarity-if'},
                            {label: 'VVS1', value: 'diamond_clarity_vvs1', className: 'diamond-clarity diamond-clarity-vvs1'},
                            {label: 'VVS2', value: 'diamond_clarity_vvs2', className: 'diamond-clarity diamond-clarity-vvs2'},
                            {label: 'VS1', value: 'diamond_clarity_vs1', className: 'diamond-clarity diamond-clarity-vs1'},
                            {label: 'VS2', value: 'diamond_clarity_vs2', className: 'diamond-clarity diamond-clarity-vs2'},
                            {label: 'SI1', value: 'diamond_clarity_si1', className: 'diamond-clarity diamond-clarity-si1'},
                            {label: 'SI2', value: 'diamond_clarity_si2', className: 'diamond-clarity diamond-clarity-si2'},
                            {label: 'I1', value: 'diamond_clarity_i1', className: 'diamond-clarity diamond-clarity-i1'},
                            {label: 'I2', value: 'diamond_clarity_i2', className: 'diamond-clarity diamond-clarity-i2'},
                            {label: 'I3', value: 'diamond_clarity_i3', className: 'diamond-clarity diamond-clarity-i3'}
                        ],
                        tip: I18n.getString('submitForm::ring::clarity::tip'),
                        scrollToOnOpen: true,
                        defaultValue: 'diamond_clarity_not_sure',
                        optional: true
                    },
                    {
                        type: 'select',
                        label: isMobile() ?
                            I18n.getString('submitForm::ring::certificate::mobileLabel') :
                            I18n.getString('submitForm::ring::certificate::label'),
                        name: 'diamond_certificate_2',
                        className: 'diamond-certificate-select',
                        verificationRegex: '^diamond_certificate_none|diamond_certificate_gia_([0-9]{8,10})$|diamond_certificate_other$',
                        noMatchRegex: '^diamond_certificate_gia_(.*)$',
                        options: [
                            {label: 'None', value: 'diamond_certificate_none', className: 'diamond-certificate diamond-certificate-none'},
                            {label: 'GIA', value: 'diamond_certificate_gia', className: 'diamond-certificate diamond-certificate-gia',
                             requires_more_details: 'Certificate No.', moreDetailsPlaceholder: 'e.g. 7349653769'},
                            {label: 'IGI, GSI or Other', value: 'diamond_certificate_other', className: 'diamond-certificate diamond-certificate-other'},
                        ],
                        scrollToOnOpen: true,
                        defaultValue: 'diamond_certificate_none',
                        optional: true
                    },{
                        type: 'select',
                        label: I18n.getString('submitForm::ring::brand::label'),
                        name: 'diamond_brand_2',
                        topText: I18n.getString('submitForm::ring::brand::description1'),
                        className: 'diamond-brand-select',
                        options: [
                            {label: 'Tiffany Co.', value: 'jewelry_brand_tiffany_co', className: 'diamond-brand diamond-brand-tiffany label-none'},
                            {label: 'Cartier', value: 'jewelry_brand_cartier', className: 'diamond-brand diamond-brand-cartier label-none'},
                            {label: 'Van Cleef', value: 'jewelry_brand_van_cleef_arpels', className: 'diamond-brand diamond-brand-van-cleef label-none'},
                            {label: 'Harry Winston', value: 'jewelry_brand_harry_winston', className: 'diamond-brand diamond-brand-harry-winston label-none'},
                            {label: 'Bvlgari', value: 'jewelry_brand_bvlgari', className: 'diamond-brand diamond-brand-bvlgari label-none'},
                            {label: I18n.getString('submitForm::ring::brand::brands::other'), value: 'nil', className: 'diamond-brand diamond-brand-other'}
                        ],
                        tip: I18n.getString('submitForm::ring::brand::tip'),
                        scrollToOnOpen: true,
                        defaultValue: 'nil',
                        optional: true
                    }
                ]
            },

            bracelet: {
                selectedFieldName: 'jewelry_style_bracelet',
                jewelryType: [
                    {
                        type: 'hidden',
                        name: 'item_type_id',
                        value: '1'
                    },
                    {
                        type: 'hidden',
                        name: 'desc',
                        value: 'Bracelets'
                    },
                    {
                        type: 'hidden',
                        name: 'item_type_1',
                        value: '7'
                    },
                    {
                        type: 'hidden',
                        name: 'type_1',
                        value: 'jewelry_bracelets'
                    },
                    {
                        type: 'hidden',
                        name: 'type_2',
                        value: 'diamond_minor_stone_batch'
                    }
                ],
                inputs: [
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::bracelet::style::label'),
                        name: 'jewelry_style_bracelet',
                        className: 'jewelry-style-ring-select',
                        options: [
                            {label: I18n.getString('submitForm::bracelet::style::styles::tennis'), value: 'jewelry_style_bracelet_tennis', className: 'jewelry-style-bracelet jewelry-style-bracelet-tennis'},
                            {label: I18n.getString('submitForm::bracelet::style::styles::charm'), value: 'jewelry_style_bracelet_charm', className: 'jewelry-style-bracelet jewelry-style-bracelet-charm'},
                            {label: I18n.getString('submitForm::bracelet::style::styles::slide'), value: 'jewelry_style_bracelet_slide', className: 'jewelry-style-bracelet jewelry-style-bracelet-slide'},
                            {label: I18n.getString('submitForm::bracelet::style::styles::bangle'), value: 'jewelry_style_bracelet_bangle', className: 'jewelry-style-bracelet jewelry-style-bracelet-bangle'},
                            {label: I18n.getString('submitForm::bracelet::style::styles::link'), value: 'jewelry_style_bracelet_link', className: 'jewelry-style-bracelet jewelry-style-bracelet-link'},
                            {label: I18n.getString('submitForm::bracelet::style::styles::other'), value: 'jewelry_style_bracelet_other', className: 'jewelry-style-bracelet jewelry-style-ring-other'}
                        ],
                        scrollToOnOpen: false
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::bracelet::metalType::label'),
                        name: 'jewelry_metal_type',
                        className: 'jewelry-style-ring-select',
                        options: [
                            {label: I18n.getString('submitForm::bracelet::metalType::types::minimum'), value: 'jewelry_metal_type_10k_gold', className: 'jewelry-style-ring jewelry-style-ring-other'},
                            {label: I18n.getString('submitForm::bracelet::metalType::types::level1'), value: 'jewelry_metal_type_14k_gold', className: 'jewelry-style-ring jewelry-style-ring-other'},
                            {label: I18n.getString('submitForm::bracelet::metalType::types::level2'), value: 'jewelry_metal_type_18k_gold', className: 'jewelry-style-ring jewelry-style-ring-other'},
                            {label: I18n.getString('submitForm::bracelet::metalType::types::level3'), value: 'jewelry_metal_type_24k_gold', className: 'jewelry-style-ring jewelry-style-ring-other'},
                            {label: I18n.getString('submitForm::bracelet::metalType::types::maximum'), value: 'jewelry_metal_type_platinum', className: 'jewelry-style-ring jewelry-style-ring-other'},
                            {label: I18n.getString('submitForm::bracelet::metalType::types::other'), value: 'jewelry_metal_type_other', className: 'jewelry-style-ring jewelry-style-ring-other'}
                        ],
                        scrollToOnOpen: false
                    },
                    {
                        type: 'number',
                        integer: true,
                        label: I18n.getString('submitForm::bracelet::numberOfDiamonds::label'),
                        name: 'diamond_number_of_stones',
                        className: 'bracelet-diamond-carat-input',
                        minValue: I18n.getFloat('submitForm::bracelet::numberOfDiamonds::minNumberOfDiamonds'),
                        tip: I18n.getString('submitForm::bracelet::numberOfDiamonds::tip'),
                        scrollToOnOpen: false
                    },
                    {
                        type: 'number',
                        label: I18n.getString('submitForm::bracelet::totalCaratWeight::label'),
                        name: 'diamond_total_carat_weight',
                        className: 'bracelet-diamond-carat-input',
                        minValue: I18n.getFloat('submitForm::bracelet::totalCaratWeight::minTotalCarat'),
                        tip: I18n.getString('submitForm::bracelet::totalCaratWeight::tip'),
                        scrollToOnOpen: false,
                        withSuggestions: true
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::bracelet::shape::label'),
                        name: 'diamond_shape',
                        className: 'diamond-shape-select',
                        options: [
                            {label: I18n.getString('submitForm::bracelet::shape::shapes::round'), value: 'diamond_shape_round', className: 'diamond-shape diamond-shape-round'},
                            {label: I18n.getString('submitForm::bracelet::shape::shapes::princess'), value: 'diamond_shape_princess', className: 'diamond-shape diamond-shape-princess'},
                            {label: I18n.getString('submitForm::bracelet::shape::shapes::cushion'), value: 'diamond_shape_cushion', className: 'diamond-shape diamond-shape-cushion'},
                            {label: I18n.getString('submitForm::bracelet::shape::shapes::marquise'), value: 'diamond_shape_marquise', className: 'diamond-shape diamond-shape-marquise'},
                            {label: I18n.getString('submitForm::bracelet::shape::shapes::emerald'), value: 'diamond_shape_emerald', className: 'diamond-shape diamond-shape-emerald'},
                            {label: I18n.getString('submitForm::bracelet::shape::shapes::other'), value: 'diamond_shape_other', className: 'diamond-shape diamond-shape-other'}
                        ],
                        scrollToOnOpen: false
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::bracelet::color::label'),
                        name: 'diamond_average_color_grade',
                        topText: I18n.getString('submitForm::bracelet::color::description1'),
                        className: 'diamond-color-select',
                        options: [
                            {label: I18n.getString('submitForm::bracelet::color::colors::notSure'), value: 'diamond_average_color_grade_not_sure'},
                            {label: 'D', value: 'diamond_average_color_grade_d'},
                            {label: 'E', value: 'diamond_average_color_grade_e'},
                            {label: 'F', value: 'diamond_average_color_grade_f'},
                            {label: 'G', value: 'diamond_average_color_grade_g'},
                            {label: 'H', value: 'diamond_average_color_grade_h'},
                            {label: 'I', value: 'diamond_average_color_grade_i'},
                            {label: 'J', value: 'diamond_average_color_grade_j'},
                            {label: 'K', value: 'diamond_average_color_grade_k'},
                            {label: 'L', value: 'diamond_average_color_grade_l'},
                            {label: 'M-Z', value: 'diamond_average_color_grade_m_z'},
                            {label: I18n.getString('submitForm::bracelet::color::colors::fancy'), value: 'diamond_average_color_grade_fancy'}
                        ],
                        tip: I18n.getString('submitForm::bracelet::color::tip'),
                        scrollToOnOpen: false,
                        defaultValue: 'diamond_average_color_grade_not_sure'
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::bracelet::clarity::label'),
                        name: 'diamond_average_clarity_grade',
                        topText: I18n.getString('submitForm::bracelet::clarity::description1'),
                        className: 'diamond-clarity-select',
                        options: [
                            {label: I18n.getString('submitForm::bracelet::clarity::clarities::notSure'), value: 'diamond_average_clarity_grade_not_sure', className: 'diamond-clarity diamond-clarity-not-sure'},
                            {label: 'FL', value: 'diamond_average_clarity_grade_fl', className: 'diamond-clarity diamond-clarity-fl'},
                            {label: 'IF', value: 'diamond_average_clarity_grade_if', className: 'diamond-clarity diamond-clarity-if'},
                            {label: 'VVS1', value: 'diamond_average_clarity_grade_vvs1', className: 'diamond-clarity diamond-clarity-vvs1'},
                            {label: 'VVS2', value: 'diamond_average_clarity_grade_vvs2', className: 'diamond-clarity diamond-clarity-vvs2'},
                            {label: 'VS1', value: 'diamond_average_clarity_grade_vs1', className: 'diamond-clarity diamond-clarity-vs1'},
                            {label: 'VS2', value: 'diamond_average_clarity_grade_vs2', className: 'diamond-clarity diamond-clarity-vs2'},
                            {label: 'SI1', value: 'diamond_average_clarity_grade_si1', className: 'diamond-clarity diamond-clarity-si1'},
                            {label: 'SI2', value: 'diamond_average_clarity_grade_si2', className: 'diamond-clarity diamond-clarity-si2'},
                            {label: 'I1', value: 'diamond_average_clarity_grade_i1', className: 'diamond-clarity diamond-clarity-i1'},
                            {label: 'I2', value: 'diamond_average_clarity_grade_i2', className: 'diamond-clarity diamond-clarity-i2'},
                            {label: 'I3', value: 'diamond_average_clarity_grade_i3', className: 'diamond-clarity diamond-clarity-i3'}
                        ],
                        tip: I18n.getString('submitForm::bracelet::clarity::tip'),
                        scrollToOnOpen: true,
                        defaultValue: 'diamond_average_clarity_grade_not_sure'
                    },
                    {
                        type: 'select',
                        label: I18n.getString('submitForm::bracelet::brand::label'),
                        name: 'jewelry_brand',
                        topText: I18n.getString('submitForm::bracelet::brand::description1'),
                        className: 'diamond-brand-select',
                        options: [
                            {label: 'Tiffany Co.', value: 'jewelry_brand_tiffany_co', className: 'diamond-brand diamond-brand-tiffany label-none'},
                            {label: 'Cartier', value: 'jewelry_brand_cartier', className: 'diamond-brand diamond-brand-cartier label-none'},
                            {label: 'Van Cleef', value: 'jewelry_brand_van_cleef_arpels', className: 'diamond-brand diamond-brand-van-cleef label-none'},
                            {label: 'Harry Winston', value: 'jewelry_brand_harry_winston', className: 'diamond-brand diamond-brand-harry-winston label-none'},
                            {label: 'David Yurman', value: 'jewelry_brand_david_yurman', className: 'diamond-brand diamond-brand-davidyurman label-none'},
                            {label: I18n.getString('submitForm::bracelet::brand::brands::other'), value: 'nil', className: 'diamond-brand diamond-brand-other'}
                        ],
                        tip: I18n.getString('submitForm::ring::brand::tip'),
                        scrollToOnOpen: true,
                        defaultValue: 'nil'
                    }
                ]
            }
        }
    )
};
